import React from 'react'

import { CalendarCancelIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/CalendarCancelIcon'
import { CheckMarkInCircleIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/CheckMarkInCircleIcon'
import { TargetIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/TargetIcon'

import styles from './recommendationExplanationContent.module.scss'
import { employmentTypes } from '../../common/constants/appConstants'

export const RecommendationExplanationContent: React.FC<RecommendationExplanationContentProps> = ({
  upcomingWeekSessionTarget,
  targetLevel,
  employmentType,
  scheduledNextWeek,
  nextWeekSessionRecommendation,
  upcomingWeekPaidTimeOff,
}) => {
  return (
    <div className={styles.container} data-test-id='RecommendationExplanationContent-open'>
      <h2>Your weekly recommendation</h2>
      <p className={styles['text-block']}>
        Our goal is to help you reach Target or Target Plus. To help you reach this goal, we calculate a weekly
        recommendation that considers potential client cancellations, PTO, and number of scheduled sessions per week.
      </p>
      <div className={styles['icon-line-item']}>
        <TargetIcon size={24} fillColor={styles.x_secondary_action} />
        <p>
          <span className={styles.strong}> {`+ ${upcomingWeekSessionTarget}`}</span> sessions recommended per week to
          reach {targetLevel}
        </p>
      </div>
      <div className={styles['icon-line-item']}>
        <CalendarCancelIcon size={24} fillColor={styles.x_secondary_action} />
        <p>
          <span className={styles.strong}>{`+ ${employmentType === employmentTypes.FULL_TIME ? 4 : 2}`}</span> sessions
          recommended per week to account for client cancellations
        </p>
      </div>
      <div className={styles['icon-line-item']}>
        <CheckMarkInCircleIcon size={24} fillColor={styles.x_secondary_action} />
        <p>
          <span className={styles.strong}>{`- ${scheduledNextWeek}`}</span> already scheduled for next week
        </p>
      </div>
      <div className={styles['icon-line-item']}>
        <CalendarCancelIcon size={24} fillColor={styles.x_secondary_action} />
        <p>
          <span className={styles.strong}>{`- ${upcomingWeekPaidTimeOff}`}</span> of PTO hours scheduled for next week
        </p>
      </div>
      {nextWeekSessionRecommendation && (
        <p>
          <span className={styles.strong}>= Total recommendation:</span> {nextWeekSessionRecommendation} additional
          sessions next week
        </p>
      )}
    </div>
  )
}

type RecommendationExplanationContentProps = {
  upcomingWeekSessionTarget: number
  targetLevel: string
  employmentType: string
  scheduledNextWeek: number
  nextWeekSessionRecommendation: number
  upcomingWeekPaidTimeOff: number
}

export default RecommendationExplanationContent
